module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "map-key"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("2000 honeysuckle survey")]), _vm._v(" "), _c('p', {
    staticClass: "icon honey"
  }, [_vm._v("honeysuckle (Lonicera periclymenum)")]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("2001 wildflower survey")]), _vm._v(" "), _c('p', {
    staticClass: "icon anemone"
  }, [_vm._v("wood anemone (Anemome nemorosa)")]), _vm._v(" "), _c('p', {
    staticClass: "icon golden"
  }, [_vm._v("golden saxifrage (Chrysosplenium oppositifolium)")]), _vm._v(" "), _c('p', {
    staticClass: "icon sorrel"
  }, [_vm._v("wood sorrel (Oxalis acetosella)")]), _vm._v(" "), _c('p', {
    staticClass: "icon lesser"
  }, [_vm._v("lesser celandine (Ranunculus ficaria)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42086c72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keys/WildFlowerKey.vue
// module id = 96
// module chunks = 1